import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const theme = {
  // primary: '#4CAF50',
  primary: '#2d6df6',
  // 060a45 2d6df6
  secondary: '#2d6df6',
  success: '#2d6df6',
  accent: '#060a45',
  info: '#060a45',
  'background-header-1': colors.grey.lighten1,
  'background-header-2': colors.grey.darken1,
  'background-header-3': colors.grey.lighten1,
  'background-header-4': colors.grey.darken1,
  'background-fill-1': colors.grey.lighten2,
  'background-fill-2': colors.grey.lighten1,
  'background-fill-3': colors.grey.lighten2,
  'background-fill-4': colors.grey.lighten1
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  }
})
